import { createReducer, on } from '@ngrx/store';
import {
  addAttachment,
  clearAttachmentStore,
  deleteAttachment,
  getAllAttachment,
  updateAttachment,
} from './attachment.action';
import { FileInformation } from '../../shared/models/app-models';

const initialState: FileInformation[] = [];

export const attachmentReducer = createReducer(
  initialState,
  on(addAttachment, (state, { file }) => {
    console.log('file :>> ', file);
    return [...state, file];
  }),

  on(updateAttachment, (state, { file, index }) => {
    let stateCopy = state.slice();
    stateCopy[index] = {
      ...file,
    };
    return [...stateCopy];
  }),

  on(deleteAttachment, (state, { index }) => {
    let array = structuredClone(state);
    // if it is already uploaded, mark it as deleted instead of removing it
    if (!array[index].fromDatabase) {
      array.splice(index, 1);
    } else {
      array[index].attachment = {
        ...array[index].attachment,
        isDeleted: true,
      };
    }
    return array;
  }),

  on(getAllAttachment, (state, { files }) => {
    let abc = files.slice()
    return abc;
  }),

  on(clearAttachmentStore, (state) => {
    return [
      ...initialState,
    ];
  }),
);
